export * from './MenuHeaderDetailsLocationText';
